import { gql } from 'apollo-boost';
import { BLAST_KEY_FRAGMENT } from '../fragments/blast-fragment';

export const CREATE_BLAST_GQL = gql`
  ${BLAST_KEY_FRAGMENT}
  mutation BlastAnnouncementCreate($input: BlastAnnouncementCreateInput!) {
    blast_announcement_create(input: $input) {
      blast_announcement {
        ...BlastKeyFragment
      }
    }
  }
`;
